module.exports = __webpack_public_path__ + "img/discount-icon.fda7c388.svg";